var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRTopnavMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-topnav-menu",
    x: 0.247,
    y: 0.634,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconR-topnav-menu1",
    serifid: "iconR-topnav-menu",
    d: "M34.248,29.479c-0,-0.635 -0.516,-1.15 -1.15,-1.15l-25.7,-0c-0.635,-0 -1.15,0.515 -1.15,1.15c-0,0.635 0.515,1.15 1.15,1.15l25.7,-0c0.634,-0 1.15,-0.515 1.15,-1.15Zm-0.013,-8.833c0,-0.635 -0.515,-1.15 -1.15,-1.15l-21.7,0c-0.634,0 -1.15,0.515 -1.15,1.15c0,0.635 0.516,1.15 1.15,1.15l21.7,0c0.635,0 1.15,-0.515 1.15,-1.15Zm0,-8.905c0,-0.62 -0.504,-1.125 -1.125,-1.125l-25.75,0c-0.62,0 -1.125,0.505 -1.125,1.125c0,0.621 0.505,1.125 1.125,1.125l25.75,0c0.621,0 1.125,-0.504 1.125,-1.125Z",
    style: {
      fill: "#808080"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRTopnavMenu);
export default __webpack_public_path__ + "static/media/iconR-topnav-menu.25e88578051363a87c9b523ac611e622.svg";
export { ForwardRef as ReactComponent };